var BaseResource = /** @class */ (function () {
    function BaseResource(client) {
        this.client = client;
    }
    return BaseResource;
}());
export default BaseResource;
//# sourceMappingURL=BaseResource.js.map